export default __webpack_public_path__ + "static/media/yedo.4ae370f3.jpg";